export default "__VITE_ASSET__BelvE$zo__"